import React, { useRef } from 'react';
import { Box, Popper, ClickAwayListener, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

const useStyles = makeStyles(() => ({
    icon: {
        cursor: 'pointer',
        display: 'block',
        fontSize: 16
    },
    dropdown: {
        borderRadius: 14,
        padding: '10px 0px',
        backgroundColor: '#fff',
        border: 'solid 1px #000',
        zIndex: 1300,
        display: 'flex',
        flexDirection: 'column'
    }
}));

interface Props {
    id: string;
    children: React.ReactNode;
    isOpen: boolean;
    onToggle: () => void;
    onClose: () => void;
}

const ToolbarButtonWithPopper = ({ id, children, isOpen, onToggle, onClose }: Props) => {
    const classes = useStyles();
    const anchorRef = useRef<HTMLDivElement | null>(null);

    return (
        <ClickAwayListener
            onClickAway={e => {
                e.stopPropagation(); // previene abrir detalle de la fila
                onClose();
            }}
        >
            <div
                ref={anchorRef}
                style={{ width: 30 }}
            >
                <Box
                    onClick={e => {
                        e.stopPropagation();
                        onToggle();
                    }}
                    className={classes.icon}
                    id={`${id}_toolbar_button`}
                >
                    <FontAwesomeIcon icon={isOpen ? faEllipsisV : faEllipsisH} />
                </Box>

                <Popper
                    open={isOpen}
                    anchorEl={anchorRef.current}
                    placement="bottom-end"
                >
                    <Box
                        className={classes.dropdown}
                        id={`${id}_toolbar_list`}
                    >
                        {children}
                    </Box>
                </Popper>
            </div>
        </ClickAwayListener>
    );
};

export default ToolbarButtonWithPopper;
